import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MaintenanceOverlayService {
    public showMaintenanceOverlay$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    constructor() {}

    public openMaintenanceOverlay() {
        this.showMaintenanceOverlay$.next(true);
        const bodyTag = document.body;
        bodyTag.classList.add('overflow-hidden');
        sessionStorage.setItem('maintenanceOverlay', 'true');
    }
}
